import { endpoints } from 'constants/endpoints'
import api from 'services/api'

import {
  toSalesCalendarCreateItemPayloadApi,
  toSalesCalendarEditItemPayloadApi,
  toSalesCalendarEditParamsApi,
  toSalesCalendarListParamsApi,
  toSalesCalendarListResponse,
  toSalesCalendarTrackingPayloadApi,
  toSalesCalendarTrackingResponse,
} from './adapters'
import type {
  SalesCalendarCreateItemPayload,
  SalesCalendarEditItemPayload,
  SalesCalendarEditParams,
  SalesCalendarListParams,
  SalesCalendarListResponse,
  SalesCalendarListResponseApi,
  SalesCalendarTrackingParams,
  SalesCalendarTrackingPayload,
  SalesCalendarTrackingResponseApi,
} from './interfaces'

export const fetchSalesCalendarList = async (
  params: SalesCalendarListParams,
): Promise<SalesCalendarListResponse> => {
  const { data } = await api.get<SalesCalendarListResponseApi>(endpoints.salesCalendar.list, {
    params: toSalesCalendarListParamsApi(params),
  })

  return toSalesCalendarListResponse(data)
}

export const postCreateSalesCalendar = async (payload: SalesCalendarCreateItemPayload) => {
  const response = await api.post(
    endpoints.salesCalendar.create,
    toSalesCalendarCreateItemPayloadApi(payload),
    { validateStatus: (status) => status < 500 },
  )

  return response
}

export const postEditSalesCalendar = async (
  params: SalesCalendarEditParams,
  payload: SalesCalendarEditItemPayload,
) => {
  const response = await api.patch(
    endpoints.salesCalendar.edit,
    toSalesCalendarEditItemPayloadApi(payload),
    {
      params: toSalesCalendarEditParamsApi(params),
    },
  )

  return response
}

export const deleteSalesCalendarApi = async (params: SalesCalendarEditParams) => {
  const response = await api.delete(endpoints.salesCalendar.delete, {
    params: toSalesCalendarEditParamsApi(params),
    validateStatus: (status) => status < 500,
  })

  return response
}

export const postGetTrackingSalesCalendar = async (
  params: SalesCalendarTrackingParams,
  payload: SalesCalendarTrackingPayload,
) => {
  const { data } = await api.post<SalesCalendarTrackingResponseApi>(
    endpoints.salesCalendar.tracking,
    toSalesCalendarTrackingPayloadApi(payload),
    { params },
  )

  return toSalesCalendarTrackingResponse(data)
}
